import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { VisitService } from '../../core/visit/visit.service';
import { NotificationService } from '../../core/notifications/notification.service';
import { FooterComponent } from '../../layout/footer/footer.component';
import { HeaderComponent } from '../../layout/header/header.component';
import { FooterNavComponent } from '../../shared/components/footer-nav/footer-nav.component';
import { IdentificationCardComponent, IdentificationCardVariant } from '../../shared/components/identification-card/identification-card.component';
import { HardwareConfigService } from '../../core/hardware/hardware-config.service';
import { HardwareChoiceCode } from '../../core/hardware/hardware.types';

interface AppointmentOption {
  variant: IdentificationCardVariant;
  choiceCode: HardwareChoiceCode;
  title: string;
  illustrationSrc: string;
  illustrationAlt: string;
}

@Component({
  selector: 'app-appointment-choice',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FooterNavComponent,
    IdentificationCardComponent,
  ],
  templateUrl: './appointment-choice.component.html',
  styleUrl: './appointment-choice.component.scss',
})
export class AppointmentChoiceComponent {
  private readonly router          = inject(Router);
  private readonly visitService    = inject(VisitService);
  private readonly notifications   = inject(NotificationService);
  private readonly hardwareConfig  = inject(HardwareConfigService);

  private readonly allOptions: AppointmentOption[] = [
    {
      variant: 'rdv',
      choiceCode: 'APPOINTMENT',
      title: "Oui, j'ai rendez-vous",
      illustrationSrc: 'assets/img/icon-illustration-appointment-badge.svg',
      illustrationAlt: "Badge d'identification avec une coche de validation",
    },
    {
      variant: 'no-rdv',
      choiceCode: 'NO_APPOINTMENT',
      title: "Non, je n'ai pas de rendez-vous",
      illustrationSrc: 'assets/img/icon-illustration-appointment-calendar.svg',
      illustrationAlt: 'Calendrier avec une croix de refus',
    },
  ];

  readonly appointmentOptions: AppointmentOption[] = this.allOptions.filter(
    (o) => this.hardwareConfig.isChoiceActive(o.choiceCode),
  );

  onOptionSelected(variant: IdentificationCardVariant): void {
    switch (variant) {
      case 'rdv':
        this.visitService.updateFlow({ hasAppointment: true });
        this.visitService.trackEvent('appointment_with');
        void this.router.navigate(['/person-notification']);
        break;
      case 'no-rdv': {
        this.visitService.updateFlow({ hasAppointment: false });
        this.visitService.trackEvent('appointment_without');
        const visitor = this.visitService.current()?.visitor ?? {};
        this.notifications.notifyReception(visitor);
        void this.router.navigate(['/visitor-welcome']);
        break;
      }
    }
  }
}
